var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("heading"),_c('hr',{staticClass:"divider"}),_vm._t("intro")],2)}
var staticRenderFns = []

export { render, staticRenderFns }